import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { coPath, toWire, withIdempotencyKey } from './shared';

/** GET `…/collection-sales-order-allocations`（`fms.customer_collection.read`）。 */
export async function fetchCollectionAllocations(id) {
  const { data: raw } = await request.get(coPath(id, '/collection-sales-order-allocations'));
  return parseVer4DetailResponse(raw);
}

/** GET `…/collection-sales-order-allocations/adjustments`。 */
export async function fetchCollectionAllocationAdjustments(id) {
  const { data: raw } = await request.get(
    coPath(id, '/collection-sales-order-allocations/adjustments'),
  );
  return parseVer4DetailResponse(raw);
}

/** POST `…/collection-sales-order-allocations`：`{ allocations[{ receiptId, salesOrderId, amount }] }`。 */
export async function createCollectionAllocations(id, payload, { idempotencyKey }) {
  const { data: raw } = await request.post(
    coPath(id, '/collection-sales-order-allocations'),
    toWire(payload),
    withIdempotencyKey(idempotencyKey),
  );
  return parseVer4DetailResponse(raw);
}

/**
 * POST `…/adjustments`：`sourceAllocationId`、`fromSalesOrderId`、`toSalesOrderId`、`amount`、`reason`、
 * `expectedFromAmount`、`expectedToAmount`；餘額已變動回 409。
 */
export async function adjustCollectionAllocation(id, payload, { idempotencyKey }) {
  const { data: raw } = await request.post(
    coPath(id, '/collection-sales-order-allocations/adjustments'),
    toWire(payload),
    withIdempotencyKey(idempotencyKey),
  );
  return parseVer4DetailResponse(raw);
}
